import Dropzone from 'react-dropzone'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Logo from 'modules/core/components/Logo'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'

import * as styles from './index.vanilla.css'
import { LogoImage } from './logoImage'

const Appareance = () => {
  const company = companies.current

  const onRemove = async () => {
    await asyncAction(() =>
      company.save({
        logo: null,
      })
    )
    company.set({
      logo: null,
    })
  }

  const onDrop = (files: File[]) => {
    const logo = files[0]

    return asyncAction(() => company.save({ logo }))
  }

  const DropzoneImage = () => {
    const currentCompany = companies.current

    return (
      <div>
        <div className={styles.dropzone}>
          <Dropzone onDrop={onDrop} accept={{ 'image/*': [] }} multiple={false}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className={styles.logo}>
                <input {...getInputProps()} />
                <Logo
                  companyLogo={currentCompany.attributes.logo}
                  alt={currentCompany.attributes.name}
                />
              </div>
            )}
          </Dropzone>
          <LogoImage />
        </div>
      </div>
    )
  }

  const RemoveButton = () => {
    if (!company.attributes.logo) return null

    return (
      <div className={styles.button}>
        <Button onClick={onRemove} type="negative">
          {i18n.t('common.remove')}
        </Button>
      </div>
    )
  }

  return (
    <PanesPadForm direction="horizontal">
      <div data-intercom-target="settings-company-logo-upload-company">
        <PanesHeader
          title={i18n.t('appearance.company_logo.title')}
          illustration="brush-pencil"
          description={[
            i18n.t('appearance.company_logo.description'),
            i18n.t('appearance.company_logo.details'),
          ]}
        />
        <div className={styles.buttons}>
          <Dropzone onDrop={onDrop} accept={{ 'image/*': [] }} multiple={false}>
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className={styles.button}>
                <input {...getInputProps()} />
                <Button type="secondary">{i18n.t('common.upload')}</Button>
              </div>
            )}
          </Dropzone>
          {RemoveButton()}
        </div>
      </div>
      {DropzoneImage()}
    </PanesPadForm>
  )
}

export default observer(Appareance)
